export default __webpack_public_path__ + "static/media/tn.b7881046.svg";